import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2214b2fe")

_pushScopeId("data-v-2214b2fe")
const _hoisted_1 = { class: "dialog__content" }
const _hoisted_2 = { class: "sponsor__card" }
const _hoisted_3 = { class: "dialog__title" }
const _hoisted_4 = { class: "dialog__item item--center" }
const _hoisted_5 = { class: "dialog__list" }
const _hoisted_6 = { class: "dialog__item item--center item--spaced" }
const _hoisted_7 = { class: "item--container" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "logo__edit icon-sketch" }, null, -1)
const _hoisted_9 = { class: "sponsor_info__ctnr" }
const _hoisted_10 = { class: "sponsor_descr__ctnr" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "descr__text" }, "Description:", -1)
const _hoisted_12 = { class: "descr__container" }
const _hoisted_13 = { class: "sponsor_phone__ctnr" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "phone__text" }, "Téléphone:", -1)
const _hoisted_15 = { class: "phone__container" }
const _hoisted_16 = { class: "dialog__list" }
const _hoisted_17 = { class: "dialog__item" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "category__text" }, "Catégorie", -1)
const _hoisted_19 = { ref: "sponsortype-container" }
const _hoisted_20 = { id: "sponsortype" }
const _hoisted_21 = {
  key: 0,
  class: "dialog__item"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "picture__text" }, "Photo principale", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "picture__edit icon-sketch" }, null, -1)
const _hoisted_24 = {
  class: "dialog__item",
  style: {"display":"none !important"}
}
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "color__text" }, "Couleur du commanditaire", -1)
const _hoisted_26 = { class: "dialog__item" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "prop__text" }, "Site Web:", -1)
const _hoisted_28 = { class: "prop__container" }
const _hoisted_29 = { class: "footer__buttons" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FileUpload = _resolveComponent("FileUpload")
  const _component_TheColorPicker = _resolveComponent("TheColorPicker")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withId(() => [
      (_ctx.dialogVisible)
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 0,
            showHeader: true,
            id: "sponsor-add",
            tabindex: "0",
            ref: "dialog",
            onClose: _ctx.closeDialog,
            onKeyup: _withKeys(_ctx.addOrEdit, ["enter"]),
            onKeydown: _withKeys(_ctx.closeDialog, ["esc"]),
            onClick: _withModifiers(_ctx.closeSelfCreatedPopup, ["stop"])
          }, {
            body: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  (_ctx.hasPicture)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: "sponsor__image",
                        style: { backgroundImage: `url(${_ctx.pictureUrl})`}
                      }, null, 4))
                    : _createCommentVNode("", true),
                  _createVNode("h2", _hoisted_3, [
                    _createVNode("div", _hoisted_4, [
                      _withDirectives(_createVNode("input", {
                        class: "sponsor_name text--center",
                        type: "text",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.addSponsor.name = $event)),
                        placeholder: "Nom du commanditaire",
                        onKeyup: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.addSponsor.name]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("div", null, [
                          _createVNode(_component_FileUpload, {
                            class: "upload",
                            ext: _ctx.supportedLogoFileExt,
                            onFileUpload: _ctx.setLogo
                          }, {
                            default: _withId(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }, 8, ["ext", "onFileUpload"]),
                          _createVNode("img", {
                            src: _ctx.addSponsor.logo,
                            class: "icon-logo"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("div", _hoisted_9, [
                          _createVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createVNode("div", _hoisted_12, [
                              _withDirectives(_createVNode("textarea", {
                                class: "sponsor__descr",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.addSponsor.description = $event)),
                                onKeyup: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
                              }, null, 544), [
                                [_vModelText, _ctx.addSponsor.description]
                              ])
                            ])
                          ]),
                          _createVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createVNode("div", _hoisted_15, [
                              _withDirectives(_createVNode("input", {
                                class: "sponsor__phone",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.addSponsor.telephone = $event)),
                                onKeyup: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
                              }, null, 544), [
                                [_vModelText, _ctx.addSponsor.telephone]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode("div", _hoisted_19, [
                    _createVNode("span", _hoisted_20, _toDisplayString(_ctx.sponsorTypeDisplayName), 1),
                    _createVNode("i", {
                      class: "icon-angle-down",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showSponsorTypeDropdown && _ctx.showSponsorTypeDropdown(...args)), ["stop"]))
                    })
                  ], 512)
                ]),
                (_ctx.hasPicture)
                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_FileUpload, {
                        class: "upload",
                        ext: _ctx.supportedPictureFileExt,
                        onFileUpload: _ctx.setPicture
                      }, {
                        default: _withId(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      }, 8, ["ext", "onFileUpload"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("div", {
                    class: "color__container",
                    style: _ctx.colorStyle,
                    onClick: _cache[8] || (_cache[8] = _withModifiers(() => _ctx.showColorPicker(!_ctx.colorPickerVisible), ["stop"]))
                  }, [
                    _createVNode(_component_TheColorPicker, {
                      color: _ctx.addSponsor.color ?? '#5D3512',
                      onColorChange: _ctx.updateColor
                    }, null, 8, ["color", "onColorChange"])
                  ], 4)
                ]),
                _createVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode("div", _hoisted_28, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "sponsor__url",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.addSponsor.websiteUrl = $event)),
                      placeholder: "www.mywebsite.com",
                      onKeyup: _cache[10] || (_cache[10] = _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"]))
                    }, null, 544), [
                      [_vModelText, _ctx.addSponsor.websiteUrl]
                    ])
                  ])
                ])
              ])
            ]),
            footer: _withId(() => [
              _createVNode("div", _hoisted_29, [
                _createVNode("div", {
                  class: ["button button--action button--grow", {'button--disabled': _ctx.nameMissing}],
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.addOrEdit && _ctx.addOrEdit(...args)))
                }, [
                  _createVNode("span", null, [
                    _createVNode("i", {
                      class: {
                                'icon-upload': _ctx.editMode && !_ctx.requestErr,
                                'icon-add': !_ctx.editMode && !_ctx.requestErr,
                                'icon-attention': _ctx.requestErr
                            }
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(_ctx.mainBtnText) + " ", 1),
                    _createVNode("i", {
                      class: {
                                    'button--disabled': _ctx.addOrEditLoading,
                                    'icon-spinner animate-spin': _ctx.addOrEditLoading
                                }
                    }, null, 2)
                  ])
                ], 2)
              ])
            ]),
            _: 1
          }, 8, ["onClose", "onKeyup", "onKeydown", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})